// Selectors for the sort dropdown
const SORT_BUTTON_SELECTOR = '.facets-sort';
const SORT_CLOSE_BUTTON_SELECTOR = '.sort-dropdown-close';
const SORT_DROPDOWN_SELECTOR = '.sort-dropdown';
const SORT_LINK_SELECTOR = '.sort-dropdown-link';

// Selectors for the filter dropdown
const sortDropdown = document.querySelector(SORT_DROPDOWN_SELECTOR);
const sortButton = document.querySelector(SORT_BUTTON_SELECTOR);
const sortCloseButton = document.querySelector(SORT_CLOSE_BUTTON_SELECTOR);

// Function to disable and enable scroll
function disableScroll() {
    document.body.classList.add('no-scroll');
}

function enableScroll() {
    document.body.classList.remove('no-scroll');
}

// Function to toggle the sort dropdown
function toggleSoftDropdown() {
    if (sortDropdown) {
        const isOpen = sortDropdown.toggleAttribute('open');

        if (isOpen) {
            disableScroll();
        } else {
            enableScroll();
        }
    }
}

// Event listener for the sort dropdown
document.addEventListener('click', (e) => {
    const target = e.target;
    const isSortButton = target === sortButton || target.closest(SORT_BUTTON_SELECTOR);
    const isSortCloseButton = target === sortCloseButton || target.closest(SORT_CLOSE_BUTTON_SELECTOR);
    const isSortDropdown = target.matches(SORT_DROPDOWN_SELECTOR);

    if (isSortButton || isSortCloseButton || isSortDropdown) {
        toggleSoftDropdown();
    }
});

// Event listener for the sort dropdown
document.addEventListener('DOMContentLoaded', () => {
    const sortLinks = document.querySelectorAll(SORT_LINK_SELECTOR);
    const urlParams = new URLSearchParams(window.location.search); // Get the URL params
    const currentSoftBy = urlParams.get('sort_by'); // Get the current sort value

    if (sortLinks.length) {
        sortLinks.forEach((link) => {
            const sortValue = link.getAttribute('data-sort'); // Get the sort value

            // Add the selected class to the current sort value
            if (sortValue == currentSoftBy) {
                link.classList.add('sort-selected');
            }

            // Event listener for the sort dropdown
            link.addEventListener('click', (e) => {
                const sortValue = e.target.getAttribute('data-sort');

                if (!sortValue) return; // If there is no sort value, return

                const url = new URL(window.location.href); // Get the current URL

                url.searchParams.set('sort_by', sortValue); // Set the sort value

                window.location.href = url.toString(); // Redirect to the new URL
            });
        });
    }
});

function initTabs() {
    const tabs = document.querySelectorAll('.tab-header .tab-links a');
    const tabContents = document.querySelectorAll('.tab-content');
    tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
            e.preventDefault();
            if (tab.classList.contains('active')) {
                return;
            }
            const tabContentId = tab.getAttribute('href').replace('#', '');
            tabs.forEach((item) => {
                item.parentElement.classList.remove('active');
            });
            tabContents.forEach((tabContent) => {
                tabContent.classList.remove('active');
            });
            tab.parentElement.classList.add('active');
            document.getElementById(tabContentId).classList.add('active');
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    initTabs();
});